import { render, staticRenderFns } from "./Ad.vue?vue&type=template&id=7f6c81b6"
import script from "./Ad.vue?vue&type=script&lang=ts"
export * from "./Ad.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports